import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import {
  faList,
  faMap,
} from '@awesome.me/kit-5231b03bd6/icons/classic/regular';
import { Views } from '~/utilities';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Text } from '@janeapp/burrito-design-system';
import { Button } from 'react-aria-components';

interface ViewToggleProps {
  currentView: Views;
  onToggle: (newView: Views) => void;
}

interface ViewToggleContent {
  icon: IconProp;
  content: string;
  label: string;
}

export const ViewToggle = ({ currentView, onToggle }: ViewToggleProps) => {
  const { icon, content, label }: ViewToggleContent =
    currentView === Views.Map
      ? { icon: faList, content: 'View list', label: 'Switch to list view' }
      : { icon: faMap, content: 'View map', label: 'Switch to map view' };

  const handleToggle = () => {
    const newView = currentView === Views.Map ? Views.List : Views.Map;
    onToggle(newView);
  };

  return (
    <div
      data-testid="view-toggle"
      className="grid-area-view-toggle fixed bottom-0 left-0 right-0 z-20 w-full cursor-pointer border-none bg-white shadow-viewToggle md:hidden"
    >
      <Button
        onPress={handleToggle}
        aria-label={label}
        className="group h-full w-full p-4 text-left font-semibold tracking-wide text-brand-80 focus:outline-none"
      >
        <span className="inline-flex w-full items-center rounded p-1 outline-offset-2 group-focus-visible:outline group-focus-visible:outline-2 group-focus-visible:outline-brand-80">
          <FontAwesomeIcon icon={icon} />
          <Text className="ml-2 text-brand-80" elementType="span">
            {content}
          </Text>
        </span>
      </Button>
    </div>
  );
};
